(() => {
  if (window.mhBuyingGuidesListening) return;
  window.mhBuyingGuidesListening = true;
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a');
    const guide = anchor?.closest('[data-guide-id]');
    if (!anchor || !guide) return;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || anchor.getAttribute('href').startsWith('#')) return;
    const path = url.pathname;
    const destinationType = path.startsWith('/products/') ? 'product' : path.startsWith('/collections/') ? 'collection' : path.includes('miki-house-at-the-plaza') ? 'store' : path.startsWith('/blogs/guides/') ? 'related_guide' : 'information';
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    const payload = {
      article_id: guide.dataset.guideId,
      guide_category: guide.dataset.guideCategory,
      destination_type: destinationType,
      destination_path: path,
      placement: anchor.dataset.guidePlacement || 'article_body'
    };
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      window.Shopify.analytics.publish('guide_cta_click', payload);
    }
  });
})();
